import React from 'react';

import PageSection from '../../components/PageSections/PageSection';
import TestimonialLegacy from '../../components/PageSections/TestimonialLegacy';

export const ContentfulComponentTestimonial = (section, i, styles) => {
  let bgColor;
  switch (section.backgroundColor) {
    case 'Grey': {
      bgColor = styles.grey;
      break;
    }
    case 'Light Blue': {
      bgColor = styles.blue;
      break;
    }
    case 'Light Purple': {
      bgColor = styles.purple;
      break;
    }
    default: {
      bgColor = styles.white;
      break;
    }
  }

  return (
    <PageSection key={i} slim className={bgColor} data-analytics-section={'legacy-testimonial'}>
      <TestimonialLegacy logoClass={styles.logo} logo={section.logo} body={section?.quote?.quote} />
    </PageSection>
  );
};
